var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.138 15.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d85a13;}.cls-2{fill:#001;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.569,
    cy: 7.569,
    r: 7.569
  }), /*#__PURE__*/React.createElement("g", {
    id: "szEaVL.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.878,7.007c0-.072,0-.193,0-.315,0-.075-.024-.108-.106-.107-.321,0-.641,0-.962,0-.084,0-.111.028-.111.111q0,1.832,0,3.663c0,.084.028.111.112.11.33,0,.66,0,.99,0,.1,0,.125-.028.125-.125,0-.6,0-1.2,0-1.808a1.436,1.436,0,0,1,.023-.315,1.278,1.278,0,0,1,.136-.394A.646.646,0,0,1,8.8,7.594a.411.411,0,0,1,.343.276,1.352,1.352,0,0,1,.093.427c.01.683.007,1.365,0,2.048,0,.1.03.126.126.125.327-.006.654,0,.981,0,.131,0,.133,0,.133-.135,0-.584,0-1.167,0-1.75A5.01,5.01,0,0,0,10.4,7.56a1.231,1.231,0,0,0-.577-.888A1.5,1.5,0,0,0,9.193,6.5a1.405,1.405,0,0,0-1.045.293C8.051,6.871,7.953,6.947,7.878,7.007ZM4.755,8.528c0,.609,0,1.218,0,1.826,0,.088.026.117.115.115q.5-.006,1,0c.092,0,.114-.033.114-.118q0-1.826,0-3.652c0-.088-.028-.116-.116-.115-.327,0-.654,0-.981,0-.129,0-.129,0-.13.135ZM6.078,5.385a.709.709,0,1,0-.708.709A.706.706,0,0,0,6.078,5.385Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.878,7.007c.075-.06.173-.136.27-.215A1.405,1.405,0,0,1,9.193,6.5a1.5,1.5,0,0,1,.634.173,1.231,1.231,0,0,1,.577.888,5.01,5.01,0,0,1,.074,1.023c0,.583,0,1.166,0,1.75,0,.133,0,.135-.133.135-.327,0-.654,0-.981,0-.1,0-.127-.027-.126-.125,0-.683.006-1.365,0-2.048A1.352,1.352,0,0,0,9.14,7.87.411.411,0,0,0,8.8,7.594a.646.646,0,0,0-.712.234,1.278,1.278,0,0,0-.136.394,1.436,1.436,0,0,0-.023.315c0,.6,0,1.205,0,1.808,0,.1-.027.126-.125.125-.33-.006-.66-.005-.99,0-.084,0-.112-.026-.112-.11q0-1.832,0-3.663c0-.083.027-.112.111-.111.321,0,.641,0,.962,0,.082,0,.107.032.106.107C7.876,6.814,7.878,6.935,7.878,7.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.755,8.528V6.722c0-.135,0-.135.13-.135.327,0,.654,0,.981,0,.088,0,.116.027.116.115q0,1.827,0,3.652c0,.085-.022.119-.114.118q-.5-.008-1,0c-.089,0-.116-.027-.115-.115C4.757,9.746,4.755,9.137,4.755,8.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.078,5.385A.709.709,0,1,1,4.66,5.376a.709.709,0,1,1,1.418.009Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2d17019b6b034df0c2c72c4041a03f6b.svg";
export { ForwardRef as ReactComponent };